import {PlayerBetPredictionViewModel} from "../../../../../domain/full-game/models/player-bet-prediction/player-bet-prediction.view-model";

export class AthleteNextGamePredictionViewModel extends PlayerBetPredictionViewModel {
  get shouldRenderBookmakerActionButton(): Boolean {
    return false
  }
}
